import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgPuzzle = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-puzzle';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.24 12v8.76h17.52V3.24H3.24zm6-5.744v1.496l.53.015c.491.014.547.024.764.132.283.143.556.434.642.688.082.239.082.587 0 .826-.087.256-.37.559-.648.694-.207.1-.277.112-.758.126l-.53.015v4.512h3.141l.073.21c.244.698.919 1.383 1.594 1.618.614.214 1.29.214 1.904 0 .675-.235 1.35-.92 1.594-1.618l.073-.21h1.621v4.48H4.76V4.76h4.48zM19.24 9v4.24h-2.992l-.015.53c-.015.502-.022.543-.142.775-.232.448-.62.695-1.091.695s-.877-.261-1.101-.706c-.108-.217-.118-.273-.132-.764l-.015-.53H10.76v-1.621l.21-.073c.491-.171 1.066-.631 1.378-1.101.479-.721.533-1.84.128-2.665-.134-.273-.429-.635-.707-.866-.19-.159-.849-.514-.953-.514-.046 0-.056-.144-.056-.82v-.82h8.48z"
    })
  }));
});
export default SvgPuzzle;